<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="panel panel-default mtl">
          <div class="panel-body">
            <div class="form-group">
              <label for="maxVotesPerUser">
                {{ lang.get('score-set.form.max-votes-per-user.label') }}
              </label>
              <input
                id="maxVotesPerUser"
                type="number"
                class="form-control"
                name="maxVotesPerUser"
                :value="scoreSet.maxVotesPerUser"
                @input="
                  e =>
                    onInput({
                      maxVotesPerUser: parseInteger(e.target.value)
                    })
                "
                @blur="e => onBlur('maxVotesPerUser', e.target.value)"
              />
            </div>
            <advanced-toggle v-model="advanced" />
            <div v-show="advanced">
              <div class="form-group">
                <label>
                  {{ lang.get('score-set.form.vote_limits.label') }}
                </label>
                <div
                  v-for="limit in ['none', 'daily', 'weekly']"
                  :key="'limit-' + limit"
                  class="radio styled"
                >
                  <input
                    :id="'vote-limits-' + limit"
                    name="voteLimits"
                    type="radio"
                    :checked="scoreSet.voteLimits === limit"
                    :value="scoreSet.voteLimits"
                    @change="e => onInput({ voteLimits: limit })"
                  />
                  <label :for="'vote-limits-' + limit">
                    {{ lang.get('score-set.form.vote_limits.' + limit) }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label for="maxVotesPerEntry">
                  {{ lang.get('score-set.form.max-votes-per-entry.label') }}
                </label>
                <input
                  id="maxVotesPerEntry"
                  type="number"
                  class="form-control"
                  name="maxVotesPerEntry"
                  :value="scoreSet.maxVotesPerEntry"
                  @input="
                    e =>
                      onInput({
                        maxVotesPerEntry: parseInteger(e.target.value)
                      })
                  "
                  @blur="e => onBlur('maxVotesPerEntry', e.target.value)"
                />
              </div>
              <div class="form-group">
                <label for="maxVotesPerCategory">
                  {{ lang.get('score-set.form.max-votes-per-category.label') }}
                </label>
                <input
                  id="maxVotesPerCategory"
                  type="number"
                  class="form-control"
                  name="maxVotesPerCategory"
                  :value="scoreSet.maxVotesPerCategory"
                  @input="
                    e =>
                      onInput({
                        maxVotesPerCategory: parseInteger(e.target.value)
                      })
                  "
                  @blur="e => onBlur('maxVotesPerCategory', e.target.value)"
                />
              </div>
              <div class="form-group">
                <div class="checkbox styled">
                  <input
                    id="votes-revokable"
                    name="votesRevokable"
                    type="checkbox"
                    :checked="scoreSet.votesRevokable"
                    @change="e => onInput({ votesRevokable: e.target.checked })"
                  />
                  <label for="votes-revokable">
                    {{ lang.get('score-set.form.votes-revokable.label') }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <div class="checkbox styled">
                  <input
                    id="votes-visible"
                    name="votesVisible"
                    type="checkbox"
                    :checked="scoreSet.votesVisible"
                    @change="e => onInput({ votesVisible: e.target.checked })"
                  />
                  <label for="votes-visible">
                    {{ lang.get('score-set.form.votes-visible.label') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6"></div>
    </div>
    <navigation v-on="$listeners" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { parseInteger } from '@/lib/utils';
import Navigation from '../Navigation';
import AdvancedToggle from '../AdvancedToggle';

export default {
  inject: ['lang'],
  components: {
    Navigation,
    AdvancedToggle
  },
  data() {
    return {
      advanced: false
    };
  },
  computed: {
    ...mapGetters('judgingFastStart', ['scoreSet'])
  },
  methods: {
    ...mapMutations('judgingFastStart', ['setScoreSet']),
    onInput(input) {
      this.setScoreSet({ ...this.scoreSet, ...input });
    },
    onBlur(property, value) {
      const integer = parseInteger(value);

      // The minimum possible value is 1
      if (integer !== null && integer < 1) {
        this.setScoreSet({ ...this.scoreSet, [property]: 1 });
      }
    },
    parseInteger
  }
};
</script>
